export default __webpack_public_path__ + "static/media/video-backup.83c2b892.jpg";